import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactCountdownClock from 'react-countdown-clock';

import { PopupContext } from '@app/dev/contexts/popup';

import { RESET_UI_BY_IDLE_TIMER } from '../../../actions/actionTypes';

import './style.scss';

const CountDownComponent = ({
  second,
  size = 60,
  timerColor = '#cbe100',
  onComplete,
  sendEventToBack,
}) => {
  const [{ closePopup }] = useContext(PopupContext);

  const hidePopup = () => {
    if (sendEventToBack) {
      dispatch({ type: RESET_UI_BY_IDLE_TIMER });
    }

    closePopup();
  };

  return (
    <ReactCountdownClock
      size={size}
      color={timerColor}
      seconds={second}
      onComplete={onComplete || hidePopup}
    />
  );
};

CountDownComponent.propTypes = {
  sendEventToBack: PropTypes.bool,
  closePopup: PropTypes.func,
  timerColor: PropTypes.string,
  second: PropTypes.number,
  size: PropTypes.number,
  onComplete: PropTypes.any,
};

export default CountDownComponent;
